import React from "react";
import styled, {keyframes} from "styled-components";

const TypingWrapper = styled.div`
  background: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].botChatBubbleBackground};
  width: fit-content;
  border-radius: 63px;
  padding-left: 2.5em;
  border-top-left-radius: 0;
  padding-right: 2.5em;
`;

const TypingAnimation = (px, props) => keyframes`
  0% {
    box-shadow: ${px} 0 0 -5px ${
  props.theme.themeColors[props.theme.activeTheme].typingDotsColor
};
  }
  30% {
    box-shadow: ${px} 0 0 2px ${
  props.theme.themeColors[props.theme.activeTheme].typingDotsColor
};
  }
  60%,
  100% {
    box-shadow: ${px} 0 0 -5px ${
  props.theme.themeColors[props.theme.activeTheme].typingDotsColor
};
  }
`;

const AnimatedDots = styled.div`
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].main};
  color: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].main};
  box-shadow: 9999px 0 0 -5px ${(props) => props.theme.themeColors[props.theme.activeTheme].main};
  animation: ${(props) => TypingAnimation("9999px", props)}
    ${(props) => props.theme.themeColors[props.theme.activeTheme].typingSpeed}
    infinite linear;
  animation-delay: 0.25s;

  &:before {
    box-shadow: 9984px 0 0 -5px ${(props) => props.theme.themeColors[props.theme.activeTheme].main};
    animation: ${(props) => TypingAnimation("9984px", props)}
      ${(props) => props.theme.themeColors[props.theme.activeTheme].typingSpeed}
      infinite linear;
    animation-delay: 0s;
    margin-left: -10px;
  }

  &:after {
    box-shadow: 10014px 0 0 -5px ${(props) => props.theme.themeColors[props.theme.activeTheme].main};
    animation: ${(props) => TypingAnimation("10014px", props)}
      ${(props) => props.theme.themeColors[props.theme.activeTheme].typingSpeed}
      infinite linear;
    animation-delay: 0.5s;
    margin-left: 10px;
  }

  &:before,
  :after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].main};
    color: ${(props) =>
      props.theme.themeColors[props.theme.activeTheme].main};
  }
`;

function Typing() {
  return (
    <TypingWrapper className="TypingWrapper">
      <AnimatedDots/>
    </TypingWrapper>
  );
}

export default Typing;
